import apiFetch from '../../apiFetch'

export default function (dossierId, token, lastAccessDate) {
  return apiFetch({ endPoint: `dossier/${dossierId}/RemoveVehicle`, method: 'PUT', body: null, token: token, lastAccessDate: lastAccessDate })
}
